import { InjectionToken } from '@angular/core';

export const FALLBACK_LANGUAGE = new InjectionToken<string>('FallbackLanguage');
